/**
 * Superpagg
 *
 * Henrique Arthur <eu@henriquearthur.com.br>
 */

 AddHomescreen = {
    init: function() {
        /**
        * For iOS
        */
        const isIos = () => {
            const userAgent = window.navigator.userAgent.toLowerCase();
            return /iphone|ipad|ipod/.test( userAgent );
        };

        const isInStandaloneModeIOS = () => ('standalone' in window.navigator) && (window.navigator.standalone);

        if (isIos() && !isInStandaloneModeIOS()) {
            $(".add-homescreen-popup.popup-ios").fadeIn();

            setTimeout(function() {
                $(".add-homescreen-popup.popup-ios").fadeOut();
            }, 8000);
        }

        /**
        * For Android
        */
        const isAndroid = () => {
            const userAgent = window.navigator.userAgent.toLowerCase();
            return /(android)/i.test(userAgent);
        };

        const isInStandaloneModeAndroid = () => (window.matchMedia('(display-mode: standalone)').matches);

        if (isAndroid() && !isInStandaloneModeAndroid()) {
            $(".add-homescreen-popup.popup-android").fadeIn();

            setTimeout(function() {
                $(".add-homescreen-popup.popup-android").fadeOut();
            }, 8000);
        }
    }
};
